import { ArrayElement } from '../types';
import { Contract } from './Contract';
import { Market, PriceSource } from './Market';
import { Operation } from './Operation';
import { OperationChain } from './OperationChain';
import { PointConstraint } from './PointConstraint';
import { SegmentConstraint } from './SegmentConstraint';
import { Trade } from './Trade';

export enum DefaultScenarioKeys {
  NEW = 'new',
  NEXT_DAY = 'next_day',
  POSTMORTEM = 'postmortem',
}

export type ScenarioComponentType =
  | 'markets'
  | 'trades'
  | 'segment_constraints'
  | 'point_constraints'
  | 'contracts';

export type ScenarioComponent = {
  id: number | string | null;
};

export type OptimizationType = 'DEFAULT' | 'BEST_PATHS_TO_POINT';

export type SettingsActionType = 'ADD' | 'REMOVE' | 'UPDATE';

export type PriceType = 'BID_ASK' | 'LAST_TRADE';

export type ScenarioComponentSettingsAction<T extends ScenarioComponentType> = {
  type: SettingsActionType;
  data: Partial<ArrayElement<Scenario[T]>>;
};

export type ScenarioComponentSettings<T extends ScenarioComponentType> = {
  actions: ScenarioComponentSettingsAction<T>[];
};

export type ScenarioSettings = {
  pricing?: {
    price_gas_date?: string;
    policy: 'NGI_ONLY';
  };
  markets: ScenarioComponentSettings<'markets'>;
  contracts: ScenarioComponentSettings<'contracts'>;
  trades: ScenarioComponentSettings<'trades'>;
  segment_constraints: ScenarioComponentSettings<'segment_constraints'>;
  point_constraints: ScenarioComponentSettings<'point_constraints'>;
  price_source: PriceSource;
  price_type: PriceType;
  simulate_spread: boolean;
  optimization_type: OptimizationType;
  strip?: string;
  optimization_settings: {
    delivery: number | null;
    receipt: Array<{
      id: number;
      loc_name?: string;
    }>;
  };
};

export type Scenario = {
  id: string;
  name: string;
  description: string;
  flow_date: string;
  optimize: boolean;
  multiCycle: boolean;
  prev_in_group: string | null;
  next_in_group: string | null;
  previous_version: number | null;
  locked: boolean;
  settings: ScenarioSettings;
  trades: Trade[];
  contracts: Contract[];
  segment_constraints: SegmentConstraint[];
  point_constraints: PointConstraint[];
  markets: Market[];
  operation_chains: OperationChain[];
  operations: Operation[];
  readonly?: boolean;
};
